namespace $ {

	export type $shm_hitalama_map_widget_entity_table2_field_type =
		| 'any'
		| 'string'
		| 'textarea'
		| 'number'
		| 'date'
		| 'period'
		| 'file'
		| 'file_pb'
		| 'atom_link'
		| 'list_link'
		| 'select'
		| 'json'
		| 'custom'

	export class $shm_hitalama_map_widget_entity_table2_field extends $giper_baza_entity.with({
		Type: $giper_baza_atom_text,
		Required: $giper_baza_atom_bool,
		Tags: $giper_baza_list_str,
		Options: $giper_baza_list_str,
		Target_dataset: $giper_baza_atom_link.to( ()=> $shm_hitalama_map_widget_entity_table2_dataset ),
		Display_field: $giper_baza_atom_link.to( ()=> $shm_hitalama_map_widget_entity_table2_field ),
		Inverse_field: $giper_baza_atom_link.to( ()=> $shm_hitalama_map_widget_entity_table2_field ),
		Custom_code: $giper_baza_atom_text,
	}) {

		map() {
			return this.dataset()?.map() ?? null
		}

		dataset() {
			const dataset = this.land().Data( $shm_hitalama_map_widget_entity_table2_dataset )
			if( dataset.fields().some( field => field.link().str === this.link().str ) ) return dataset
			const link = this.link().str
			return this.land().Data( $shm_hitalama_map ).Datasets()?.remote_list().find( candidate =>
				candidate.fields().some( field => field.link().str === link )
			) ?? null
		}

		history_events() {
			return this.map()?.history_maybe()?.events_for( this ) ?? []
		}

		private history_value< Value >( property: string, before: Value, after: Value ) {
			const dataset = this.dataset()
			$shm_hitalama_map_history.capture( this.map(), {
				type: 'field_set',
				target: this.link().str,
				targets: [
					... dataset ? [ dataset.link().str ] : [],
					... [ before, after ].filter( value => typeof value === 'string' && $giper_baza_link.check( value ) !== null ) as string[],
				],
				before,
				after,
				meta: { property, ... dataset ? { dataset: dataset.link().str } : {} },
			}, 'Изменение столбца' )
			return after
		}

		// Wire identifies a pending call by function identity as well as host/args.
		// Returning a new closure from this accessor breaks suspended title writes.
		private readonly title_channel = ( next?: string )=> {
			if( next === undefined ) return super.title()
			const before = super.title()
			const result = super.title( next )
			return this.history_value( 'title', before, result )
		}

		override get title() { return this.title_channel }

		@ $mol_mem
		type( next?: $shm_hitalama_map_widget_entity_table2_field_type ): $shm_hitalama_map_widget_entity_table2_field_type {
			if( next === undefined ) return ( this.Type()?.val() ?? 'any' ) as $shm_hitalama_map_widget_entity_table2_field_type
			const before = this.type()
			const result = ( this.Type( next )?.val( next ) ?? 'any' ) as $shm_hitalama_map_widget_entity_table2_field_type
			return this.history_value( 'type', before, result )
		}

		required( next?: boolean ): boolean {
			if( next === undefined ) return this.Required()?.val() ?? false
			const before = this.required()
			const result = this.Required( next )?.val( next ) ?? false
			return this.history_value( 'required', before, result )
		}

		tags( next?: readonly string[] ): string[] {
			if( next === undefined ) return [ ... this.Tags()?.items() ?? [] ]
			const before = this.tags()
			const result = [ ... this.Tags( next as string[] )?.items( next as string[] ) ?? [] ]
			return this.history_value( 'tags', before, result )
		}

		options( next?: readonly string[] ): string[] {
			if( next === undefined ) return [ ... this.Options()?.items() ?? [] ]
			const before = this.options()
			const result = [ ... this.Options( next as string[] )?.items( next as string[] ) ?? [] ]
			return this.history_value( 'options', before, result )
		}

		target_dataset( next?: $shm_hitalama_map_widget_entity_table2_dataset | null ) {
			if( next === undefined ) return this.Target_dataset()?.remote() ?? null
			const before = this.Target_dataset()?.remote()?.link().str ?? ''
			const result = this.Target_dataset( null )?.remote( next ) ?? null
			this.history_value( 'target_dataset', before, result?.link().str ?? '' )
			return result
		}

		display_field( next?: $shm_hitalama_map_widget_entity_table2_field | null ) {
			if( next === undefined ) return this.Display_field()?.remote() ?? null
			const before = this.Display_field()?.remote()?.link().str ?? ''
			const result = this.Display_field( null )?.remote( next ) ?? null
			this.history_value( 'display_field', before, result?.link().str ?? '' )
			return result
		}

		inverse_field( next?: $shm_hitalama_map_widget_entity_table2_field | null ) {
			const atom = this.Inverse_field( next === undefined ? undefined : null )
			if( next === undefined ) return atom?.remote() ?? null
			const before = atom?.remote()?.link().str ?? ''
			if( next === null ) atom?.remote( null )
			else atom?.val( new $giper_baza_link( next.link().str ) )
			const result = atom?.remote() ?? null
			this.history_value( 'inverse_field', before, result?.link().str ?? '' )
			return result
		}

		custom_code( next?: string ): string {
			if( next === undefined ) return this.Custom_code()?.val() ?? ''
			const before = this.custom_code()
			const result = this.Custom_code( next )?.val( next ) ?? ''
			return this.history_value( 'custom_code', before, result )
		}

	}

}
